// Staging — same project as development for now (qbaamzphxgfjavyercpz).
export const environment = {
  production: false,
  environmentName: 'staging',
  supabaseUrl: 'https://qbaamzphxgfjavyercpz.supabase.co',
  supabaseKey: 'sb_publishable_UjVCT-2QBW8nWTdWaLrPBA_kgLPzXQs',
};
